import {useMutation} from '@tanstack/vue-query';
import { getApi } from '../api';

export default (accountId: number) => useMutation({
    mutationFn: (dialog: object) => {
        const { api, baseURL } = getApi();
        return api.put(`/api/v2/accounts/${accountId}/dialogs/${dialog.id}`, dialog, { baseURL, useOriginalToken: true }).then(res => res.data.data)
    },
})
